import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { DateRangePickerService } from '../../date-range-picker.service';
import { DateRangePickerMonthComponent } from '../../date-range-picker-month/date-range-picker-month.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { LetDirective } from '@directives/app-let.directive';
import {
  NgClickOutsideDirective,
  NgClickOutsideExcludeDirective,
} from 'ng-click-outside2';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { openCloseTriggerAnimation } from 'src/app/animations/openClose.animation';

@Component({
  selector: 'app-date-range-picker-desktop-modal',
  standalone: true,
  imports: [
    CommonModule,
    DateRangePickerMonthComponent,
    SvgIconComponent,
    LetDirective,
    NgClickOutsideDirective,
    NgClickOutsideExcludeDirective,
  ],
  templateUrl: './date-range-picker-desktop-modal.component.html',
  styleUrl: './date-range-picker-desktop-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [openCloseTriggerAnimation],
})
export class DateRangePickerDesktopModalComponent implements OnInit {
  @Input() skipText = '';
  @Input() noSkipText = '';

  @Output() closeModal = new EventEmitter<void>();

  isDisabledPrevMonth = false;
  isDisabledNextMonth = false;

  private dateRangePickerService = inject(DateRangePickerService);
  private destroyRef = inject(DestroyRef);

  firstMonth$ = this.dateRangePickerService.firstMonth$;
  secondMonth$ = this.dateRangePickerService.secondMonth$;

  months$ = this.dateRangePickerService.months$;

  isOpen$ = this.dateRangePickerService.isOpen$;

  ngOnInit(): void {
    this.updateDisabledButtons();
  }

  onNextMonthClick() {
    if (this.isDisabledNextMonth) {
      return;
    }

    this.dateRangePickerService.onNextMonthClick();
  }

  onPrevMonthClick() {
    if (this.isDisabledPrevMonth) {
      return;
    }

    this.dateRangePickerService.onPrevMonthClick();
  }

  onSkipClick() {
    this.dateRangePickerService.onClickSkip();
    this.closeModal.emit();
  }

  onClickOutside() {
    this.dateRangePickerService.onCloseModal();
  }

  private updateDisabledButtons() {
    this.dateRangePickerService.isDisabledPrevMonth$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isDisabledPrevMonth) => {
        this.isDisabledPrevMonth = isDisabledPrevMonth;
      });
    this.dateRangePickerService.isDisabledNextMonth$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isDisabledNextMonth) => {
        this.isDisabledNextMonth = isDisabledNextMonth;
      });
  }
}
